import { createCachedSelector } from 're-reselect';

import getDropdownSegment from '@/state/selectors/navigation/get-dropdown-segment';
import { IStore } from '@/state/slices/typings';

const isExpectedDropdownSegment = createCachedSelector(
	[
		getDropdownSegment,
		(_: IStore, segmentIndex: number) => segmentIndex,
		(_: IStore, __: number, expectedSegment: string) => expectedSegment,
	],
	(dropdownSegment, _, expectedSegment) =>
		dropdownSegment === expectedSegment,
)(
	(_: IStore, segmentIndex: number, expectedSegment: string) =>
		`${segmentIndex}_${expectedSegment}`,
);

export default isExpectedDropdownSegment;
